import axios from 'axios';
import { REFERRAL_APP_API_URL } from './baseUrls';

const API_URL = REFERRAL_APP_API_URL;
// 注册用户的请求函数
export const registerUser = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/register`, userData);
    return response.data; // 返回响应数据
  } catch (error) {
    throw error.response.data; // 抛出错误信息
  }
}; 

// 登录用户的请求函数
export const loginUser = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/login`, userData);
    return response.data; // 返回响应数据
  } catch (error) {
    throw error.response.data; // 抛出错误信息
  }
};

// 修改用户密码的请求函数
export const changeUserPassword = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/change-password`, userData);
    return response.data; // 返回响应数据
  } catch (error) {
    throw error.response.data; // 抛出错误信息
  }
};



// 提交患者病案的请求函数
export const BinganPatient = async (userData) => {
    try {
        const response = await axios.post(`${API_URL}/bingan-patient`, userData);
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};
